import React from 'react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';

import ListBreaksPage from  '../pages/ListBreaks/ListBreaksPage.jsx';

const Embed = () => (

  <div>

    <Route  path='embed/breaks' component={ListBreaksPage}  />

    Embed no header test, not needed but making sure routes are setup properly
    <Link to="/breaks">Breaks</Link>
  </div>
)

export default Embed;



// WEBPACK FOOTER //
// ./public/pages/Embed.jsx